import script from "./VoiceInputSection.vue?vue&type=script&setup=true&lang=js"
export * from "./VoiceInputSection.vue?vue&type=script&setup=true&lang=js"

import "./VoiceInputSection.vue?vue&type=style&index=0&id=38d67e9c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38d67e9c"]])

export default __exports__